import { contactInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">{contactInfo.title}</h2>
          <p className="text-foreground-600 mb-8 leading-relaxed">{contactInfo.intro}</p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-500">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-950">{contactInfo.email}</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600">
                <i className="ri-qq-line text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">QQ群号</div>
              <div className="text-sm font-medium text-foreground-950">{contactInfo.qq}</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-secondary-100/80 text-secondary-600">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-medium text-foreground-950">{contactInfo.wechat}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}